/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invitesubbonusbtnok4Inputs */



/**
* | output |
* | --- |
* | "Nice!" |
*
* @param {Invitesubbonusbtnok4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const invitesubbonusbtnok4 = /** @type {((inputs?: Invitesubbonusbtnok4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invitesubbonusbtnok4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Nice!")
	if (locale === "es") return /** @type {LocalizedString} */ ("¡Genial!")
	return /** @type {LocalizedString} */ ("Круто!")
});
export { invitesubbonusbtnok4 as "inviteSubBonusBtnOk" }